/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// UTILS
import { trackEvent } from 'utils/tracking/tracking';
import { refreshAds } from 'utils/ads';
// STYLES
// (css-in-js, imported as JS from external file, turned into CSS via library used in utils)
import styles from 'components/shared/skip/skip_styles';
import { createStyles } from 'utils/styles';
import chevronRightSolid from 'icons/chevron-right-solid.svg'
import Icon from 'components/shared/icon/icon';

const sheet = createStyles(styles, { link: false });


/* ========== ~~~~~~~~~~ SKIP : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary

export default (props) => {
  if (!props.canSkipFrames) { return null; }

  const {
    embedUUID, frameData, frameState, framePhase, contentType,
    currentUniqueState, cookieId, contentId, isPubPortalPreview,
    saveContentSkipResponse, submitUDCData
  } = props;

  const handleClick = () => {
    // ::: tracking: skip clicked ::: //
    refreshAds();
    tackSkipEvent();
    recordSkipClick();
  };

  const tackSkipEvent = () => {
    const isUDC = contentType === 'userDataCollection';
    const target = isUDC ? 'udc' : undefined;
    const contentProperties = isUDC ? null : props;
    const typeSpecificData = isUDC ? {
      skip: true,
      udcId: currentUniqueState.udcId,
      publisherName: currentUniqueState.contentProperties.publisherName
    } : {
      skip: true
    };
    trackEvent({ type: 'click', name: 'ceuContentEngaged', target, props: contentProperties, additionalProps: typeSpecificData })
  };

  const recordSkipClick = () => {
    switch (contentType) {
      case 'userDataCollection':
        submitUDCData(contentId, getEngagementData(), isPubPortalPreview, null);
        break;
      case 'mixed':
      // fall through
      default:
        saveContentSkipResponse(contentId, getEngagementData(), isPubPortalPreview, null);
    }
    return skipToNextFrame();
  };

  const getEngagementData = () => {
    let contentSpecificData = Object.create(null);
    let frameSpecificData = Object.create(null);

    switch (contentType) {
      case 'mixed':
        const isQuestionBased = frameData.type !== 'story';
        contentSpecificData = {
          contentType: frameData.type,
          contentUUID: isQuestionBased ? frameData.question.id : frameData.story.id,
          contentSignature: isQuestionBased ? frameData.questionSignature : frameData.story.contentSignature,
        };

        frameSpecificData = {
          ...isQuestionBased ? { questionText: frameData.question.text } : { headline: frameData.story.text },
          ...!isQuestionBased && { storyUrl: frameData.story.storyUrl }
        };
        break;
      case 'userDataCollection':
        contentSpecificData = {
          contentType: 'user_data_collection',
          contentUUID: currentUniqueState.udcId,
          contentSignature: currentUniqueState.contentSignature,
        };
        break;
      default:
        return null;
    }

    return {
      cookieId,
      embedUUID,
      pageUrl: window.parent.document.location.href,
      ...contentSpecificData,
      contentProperties: {
        engagementType: 'SKIP',
        ...frameSpecificData,
      }
    }
  };

  const skipToNextFrame = () => props.advanceFrame(props.contentId);

  const isHidden = contentType !== 'ad' && frameState !== 'initial' && framePhase !== 'entry';

  return (
    <button className={`${sheet.classes.skip} skip hidden-${isHidden}`}
      onClick={handleClick}>
      <div className={'skipinner'}>
        <div>{`Skip`}</div>
        <Icon svg={chevronRightSolid} color={sheet.classes.skip.color} size={12}/>
      </div>
    </button>
  );
};
